import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-multi-select-input-tags',
  templateUrl: './multi-select-input-tags.component.html',
  styleUrls: ['./multi-select-input-tags.component.scss']
})
export class MultiSelectInputTagsComponent implements OnInit {

  @Input() data: string[] = [];
  @Input() selected: string[] = [];
  @Output() selectionChange = new EventEmitter<string[]>();

  search: string = '';
  filteredData: string[] = [];
  showDropdown: boolean = false;

  constructor(private readonly elementRef: ElementRef) { }

  ngOnInit() {
    this.filteredData = [...this.data];
  }

  onFocus() {
    this.showDropdown = this.filteredData.length > 0;
  }

  onSearchChange() {
    const term = this.search.trim().toLowerCase();

    if (!term) {
      this.filteredData = [...this.data];
    } else {
      this.filteredData = this.data.filter(x =>
        x.toLowerCase().includes(term)
      );
      if (this.filteredData.length === 0) {
        this.filteredData.push(this.search);
      }
    }

    this.showDropdown = this.filteredData.length > 0;
  }

  handleEnter() {
    if (this.search.trim().length === 0) return;
    const match = this.data.find(x => x.toLowerCase() === this.search.toLowerCase());
    const value = match ?? this.search.trim();
    this.addValue(value);
  }

  addValue(value: string) {
    if (!this.selected.includes(value) && value.trim() !== "") {
      this.selected.push(value);
      this.emitChanges();
    }
    this.search = '';
    this.filteredData = this.data;
    this.showDropdown = false;
  }

  removeTag(value: string) {
    this.selected = this.selected.filter(x => x !== value);
    this.emitChanges();
  }


  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.showDropdown = false;
      if (this.search?.trim()) {
        this.addValue(this.search)
      }
    }
  }

  emitChanges() {
    this.selectionChange.emit(this.selected);
  }

}